<template>
  <div class="settings-section">
    <div class="section-header">
      <h2 class="section-title">Bulk Import Product Costs</h2>
      <span class="optional-badge">OPTIONAL</span>
    </div>

    <StatisticsCards :statistics="statistics" />

    <WorkflowStep 
      step-number="1"
      title="Download your product list"
      description="Get a CSV with all your products. Fill in the COGS and Other Costs columns.">
      <button class="download-button" @click="$emit('download-template')" :disabled="downloading">
        <i class="download icon"></i>
        Download CSV Template
      </button>
      <CSVExample />
    </WorkflowStep>

    <WorkflowStep 
      step-number="2"
      title="Fill in your costs"
      description="Open in Excel or Google Sheets. Enter COGS (required) and Other Costs (optional - shipping, prep, etc.)" />

    <WorkflowStep 
      step-number="3"
      title="Upload completed file"
      description="Drag and drop your file or click to browse.">
      <FileUploadArea 
        :uploading="uploading"
        @file-selected="$emit('file-selected', $event)"
        @file-removed="$emit('file-removed')"
        @error="$emit('error', $event)" />
    </WorkflowStep>
  </div>
</template>

<script>
import StatisticsCards from './StatisticsCards.vue'
import WorkflowStep from './WorkflowStep.vue'
import CSVExample from './CSVExample.vue'
import FileUploadArea from './FileUploadArea.vue'

export default {
  name: 'BulkImportSection',
  components: {
    StatisticsCards,
    WorkflowStep,
    CSVExample,
    FileUploadArea
  },
  props: {
    statistics: {
      type: Object,
      required: true
    },
    downloading: {
      type: Boolean,
      default: false
    },
    uploading: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
@import './styles/BulkImportSection.css';
</style>




// WEBPACK FOOTER //
// BulkImportSection.vue?5a24adda